const currentDate = new Date()
export default {
  projects: [],
  companies: [],
  updateJobsByBuilding: {},
  projectionScopeGeneration: 0,
  projectionScopeKey: null,
  projectionLoads: {},
  filterDates: {
    beginAt: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() - 3, 1)),
    endAt: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 3, 1)),
  },
  offCanvasFilterDates: {
    beginAt: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() - 3, 1)),
    endAt: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 3, 1)),
  },
  selectedDetail: {},
  curveID: 0,
  cubBased: false,
  forecastBased: false,
  xlsxData: {},
  selectedGraph: '',
  filterDocs: {
    paidData: [],
    toPayData: [],
  },
  graphData: {
    paidValues: [],
    toPayValues: [],
    disbursements: [],
    physicals: [],
    predicted: [],
    baseline: [],
    measured: [],
    scheduleCurves: [],
    scheduleSource: null,
    takenTo: { byItem: [], byMonth: [] },
    takenFrom: { byItem: [], byMonth: [] }
  },
  graphRequestKey: null,
  scheduleAnalysis: {
    requestKey: null,
    loading: false,
    error: null,
    data: null,
  },
  graphMaxDates: {
    begin: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() - 3, 1)),
    end: new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 3, 1)),
  },
  advancedItems: [],
  projectionTable: false,
  tableMonthSelected: ''
};
